<template>
  <div
    class="clinicalInfoCard"
    :class="
      isExpanded ? 'clinicalInfoCard--expanded' : 'clinicalInfoCard--short'
    "
  >
    <h4 class="clinicalInfoCard-headline">
      {{ $i18n.t(item.headline) }}
    </h4>
    <ModalVideo
      class="clinicalInfoCard-video"
      v-if="item.vimeoId"
      :vimeoId="item.vimeoId"
      :title="item.headline"
    >
      <BackgroundImage
        class="clinicalInfoCard-video-background"
        :name="item.image"
      />
    </ModalVideo>
    <div class="clinicalInfoCard-pic" v-else>
      <BackgroundImage
        class="clinicalInfoCard-pic-background"
        :name="item.image"
      />
    </div>
    <p
      class="clinicalInfoCard-text"
      :class="isExpanded ? '' : 'clinicalInfoCard-text--short'"
    >
      {{ clampedText }}
    </p>
    <FlippingMultiImage
      name="img_arrow_down"
      @click="isExpanded = !isExpanded"
      class="clinicalInfoCard-arrow"
    />
  </div>
</template>

<script>
import BackgroundImage from "@/components/BackgroundImage";
import ModalVideo from "@/components/ModalVideo";
import FlippingMultiImage from "@/components/FlippingMultiImage";

export default {
  name: "ClinicalInfoCard",
  components: {
    ModalVideo,
    BackgroundImage,
    FlippingMultiImage,
  },
  data: function() {
    return {
      isExpanded: false,
    };
  },
  props: {
    item: Object,
  },
  methods: {
    toggleExpanded() {
      this.$data.isExpanded = !this.$data.isExpanded;
      if (!this.$data.isExpanded) {
        this.clampText();
      }
    },
  },
  computed: {
    clampedText() {
      const t = this.$i18n.t(this.$props.item.text);
      if (this.$data.isExpanded) {
        return t;
      }
      const words = t.split(" ");
      let shortened = words[0];
      let i = 1;

      const acceptableLength = 40;

      while (shortened.length < acceptableLength && i < words.length) {
        shortened = `${shortened} ${words[i]}`;
        i++;
      }
      if (i < words.length - 1) shortened = `${shortened} ...`;
      return shortened;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss";

.clinicalInfoCard {
  background: white;
  border-radius: 15px;
  width: 310px;
  cursor: pointer;
  @include breakpoint(xs) {
    width: 240px;
  }
  @include breakpoint(s) {
    width: 240px;
  }
  text-align: center;
  margin: 10px;
  position: relative;
  padding-bottom: 20px;
  margin-bottom: 50px;

  &--expanded {
    @include flex-v(flex-start, stretch);
  }

  &--short {
    @include flex-v(flex-start, stretch);
    height: 325px;
    overflow: hidden;
    @include breakpoint(xs) {
      height: auto;
    }
  }

  &-arrow {
    display: flex;
    align-self: center;
    //position: absolute;
    bottom: 15px;
    height: 24px;
    margin-top: -15px;
    @include breakpoint(xs) {
      margin-top: 20px;
    }
  }

  &-headline {
    padding: 15px;
    height: 100px;
    font-family: $font_nettoBold;
    @include text(20px, 24px, 0.17px);
    @include flex-h(center, center);
    @include ie_or_edge() {
      @include text(18px, 24px, 0.17px);
    }
    @include breakpoint(xs) {
      @include text(16px, 20px, 0.03px);
      height: auto;
    }
  }

  &-pic,
  &-video {
    height: 120px;
    padding: 0;
    &-background {
      height: 100%;
      background-size: cover;
      @include flex-h(center, center);
    }
  }
  &-text {
    text-align: left;
    padding: 15px;
    margin-bottom: 20px;
    font-family: $font_nettoRegular;
    hyphens: auto;
    line-height: 20px;
    @include breakpoint(xs) {
      @include text(14px, 16px, 0.03px);
      height: auto;
      margin-bottom: 0px;
    }
  }
}
</style>
